import type { CSSProperties } from "react";
import { editorialIdentity } from "../lib/identity";

/** Deliberately graphic, not an imitation of a historical photograph. */
export function EditorialArtwork({ seed, category = "", era = "", className = "" }: {
  seed: string; category?: string; era?: string; className?: string;
}) {
  const { paper, ink, accent, variant } = editorialIdentity(seed, category);
  return <span className={`editorial-artwork artwork-${variant} ${className}`} style={{ "--art-paper": paper, "--art-ink": ink, "--art-accent": accent } as CSSProperties} aria-hidden="true">
    <svg viewBox="0 0 600 360" fill="none" preserveAspectRatio="xMidYMid slice">
      <g className="artwork-lines" stroke="currentColor" strokeWidth="1.3">
        {variant === 0 && <><path d="M-20 68H620M-20 292H620M94-20V380M506-20V380" /><circle cx="300" cy="173" r="144" /><circle cx="300" cy="173" r="119" /></>}
        {variant === 1 && <><path d="M-60 354 300-20 660 354M-60 314 300-60 660 314M-60 394 300 20 660 394" /><path d="M-20 112H620M-20 264H620" /></>}
        {variant === 2 && <><ellipse cx="300" cy="180" rx="234" ry="100" transform="rotate(-25 300 180)" /><ellipse cx="300" cy="180" rx="234" ry="100" transform="rotate(25 300 180)" /><ellipse cx="300" cy="180" rx="234" ry="100" transform="rotate(90 300 180)" /></>}
      </g>
      <g className="artwork-glyph">
        <path className="artwork-connection" d="M210 114 300 276 390 114" pathLength="1" />
        <circle className="artwork-dot art-one" cx="210" cy="114" r="56" />
        <circle className="artwork-dot art-two" cx="390" cy="114" r="56" />
        <circle className="artwork-dot art-three" cx="300" cy="276" r="56" />
      </g>
    </svg>
    <span className="artwork-caption"><span>{era || "Because.FM"}</span><span>∵</span></span>
  </span>;
}
